<template>
  <div class="container h-100">
    <div class="row justify-content-center align-items-center h-100">
      <div class="col-11 col-md-4">
        <form @submit.prevent="submit">
          <h2 class="text-center mb-3">dmp 管理画面</h2>
          <h5 class="text-center mb-5">パスワードのリセット</h5>
          <div class="mb-3">
            <input type="email" class="form-control" v-model="email" placeholder="メールアドレス" required>
          </div>
          <div class="mb-3">
            <button class="btn btn-primary w-100" :disabled="!email">確認メールを送信</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import {forgotPassword} from '../../../api/admin/AuthApi';
import useFlashMessage from '../../../composables/useFlashMessage';

const {successMessage} = useFlashMessage();

const email = ref();

/**
 * ログイン
 *
 * @returns {Promise<void>}
 */
const submit = async () => {
  await forgotPassword(email.value);
  email.value = null;
  successMessage('パスワードを再設定するためのメールを送信しました。')
}
</script>

